export default __webpack_public_path__ + "static/media/CarImages.SedonaGallery6.84903bef.jpg";